module.exports = __webpack_public_path__ + "img/ultra-logo.d59d44bd.png";